/**
 * KEPT FOR BACKWARDS COMPATIBILITY
 * DO NOT EDIT THIS FILE
 * USE {@link ../main.ts}
 */

/**
 * Styles
 */
import 'regenerator-runtime/runtime'
import './index.scss'
/**
 * AEM components
 */
import '@components/map-app/map-app.js'
import '@components/button/button.js'
import '@components/slider/slider.js'
import '@components/contact/contact.js'
import '@components/text/text.js'
import '@components/download/download.js'
import '@components/image/responsiveimage/parallax/zoom.js'
import '@components/image/responsiveimage/parallax/vertical-depth.js'
import '@components/videocontainer/parallax-effects/vertical-scrolling.js'
import '@components/videocontainer/parallax-effects/image-mask.js'
import '@components/pagestage/pagestage-textonly.js'
import '@components/form-container/form-container.js'
import '@components/media-gallery/media-gallery.js'
import '@components/stockticker/stockticker'
import '@components/carousel/carousel'
import '@components/next-25/next25-content-brickcarousel/next25-content-brickcarousel'
import '@components/interactiontoolbar/interactiontoolbar.js'
import '@components/abblinkspopup/abblinkspopup'
import '@components/parallax-scroll/parallax-scroll'
import '@components/page-tracker/page-tracker'
import '@components/slideupteasers/slideupteasers'
import '@components/pagestagev2/pagestagev2'
import '@components/teaserHeightAdjustment/teaserHeightAdjustment'
import '@components/footer/footer'
import '@components/teasers-with-stage/teasers-with-stage'
import '@components/termsandconditions/termsandconditions.js'
import '@components/termsandconditions/terms-of-use-link.js'
import '@components/facts-and-figures/facts-and-figures'
import '@components/marquee/marquee'
import '@components/horizontalteaser-v2/horizontalTeaser'
import '@components/accordion/accordion.js'
import '@components/quote/quote.js'
import '@components/translation-dashboard/translation-dashboard'
import '@components/powerPortal-form/powerPortal-form.js'
import '@components/powerPortal-form/powerPortal-signUpNewUser.js'
import '@components/powerPortal-form/powerPortal-existingUser.js'
import '@components/next-25/next25-Bricks/next25-bricks.js'
import '../dcx/cop/common/agreement-details'
import '../dcx/cop/common/breadcrumb-update'
import '../dcx/cop/common/cop-header-mobile'
import '../dcx/cop/common/hide-country-selector-for-non-cop'
import '../dcx/cop/common/cybersecurity-patch-files-visibility'
import '../dcx/cop/common/resource-documentation-tab-visibility'

import { CountrySelector } from '@components/countryselector/countryselector.js'
import { CustomSelect } from '@components/custom-select'
import { Footnotes } from '@components/footnotes/footnotes'
import { Header } from '@components/header/header'
import { Profile } from '@components/header/profile'
import { ScrollIndicator } from '@components/homepage-stage/homepage-stage'
import { Languagenavigation } from '@components/languagenavigation/languagenavigation'
import { Lightbox } from '@components/lightbox/lightbox'
import { ModalContainerPlugin } from '@components/modal-container/modal-container-plugin'
import { Navigation } from '@components/navigation/navigation'
import { TeaserDropDown } from '@components/on-page-navigation/navigation-teaser'
import { ProductTeaserContainer } from '@components/productteasercontainer/productteasercontainer'
import { AgendaWatermarkTitle } from '@components/specialevent/specialevent.js'
import { StickyHeaderSearch } from '@components/stickyheadersearch/stickyheadersearch.js'
import { TeaserContainer } from '@components/teasercontainer/teasercontainer'
import { VideoEmbed } from '@components/videoembed/videoembed'

import handleFilterbarInitialLoadingSpinner from './js/utils/filterbarInitialLoadingSpinner'
import { initRequest } from './js/utils/request'

ModalContainerPlugin().init()
CustomSelect().init()
Footnotes().init()
AgendaWatermarkTitle().init()

Array.from(document.querySelectorAll('.cmp-teasercontainer'))
  .filter(teaserContainer => teaserContainer.querySelector('div'))
  .forEach(teaserContainer => TeaserContainer(teaserContainer).init())

Header().init()
Navigation().init()
Profile().init()
Languagenavigation().init()
ScrollIndicator().init()
StickyHeaderSearch().init()
CountrySelector().init()
TeaserDropDown().init()

Array.from(document.querySelectorAll('.cmp-videoembed')).forEach(embed => VideoEmbed(embed).init())

Array.from(document.querySelectorAll('a.link_external')).forEach(link => {
  link.target = '_blank'
  link.rel = 'noreferrer noopener'
})

Lightbox().init()

Array.from(document.querySelectorAll('.cmp-productteasercontainer'))
  .filter(teaserContainer => teaserContainer.querySelector('div'))
  .forEach(teaserContainer => ProductTeaserContainer(teaserContainer).init())

initRequest()
handleFilterbarInitialLoadingSpinner()
